import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { ThemeProvider } from 'styled-components';
import StyledSuccessAnimation from './StyledSuccessAnimation';
var SuccessAnimation = function (props) {
    var className = props.className, onSuccess = props.onSuccess, color = props.color, id = props.id, text = props.text, waitTime = props.waitTime;
    var _a = useState(color || '#000'), _color = _a[0], setColor = _a[1];
    var theme = {
        color: _color,
    };
    useEffect(function () {
        if (color !== undefined && CSS.supports('color', color)) {
            setColor(color);
        }
    }, [color]);
    useEffect(function () {
        var timeout = waitTime || 1400;
        setTimeout(onSuccess, timeout);
    });
    var _className = classNames('success-animation', className);
    var circleClassName = classNames('success-animation__check-svg__path success-animation__check-svg__path--circle', 'success-animation__check-svg__path');
    var checkClassName = classNames('success-animation__check-svg__path success-animation__check-svg__path--check', 'success-animation__check-svg__path');
    var textClassName = classNames('success-animation__text');
    return (React.createElement(ThemeProvider, { theme: theme },
        React.createElement(StyledSuccessAnimation, { id: id || '', className: _className },
            React.createElement("svg", { className: 'success-animation__check-svg', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 130.2 130.2' },
                React.createElement("circle", { className: circleClassName, "aria-describedby": 'action complete background circle', fill: 'none', stroke: 'currentColor', strokeWidth: '3', strokeMiterlimit: '10', cx: '65.1', cy: '65.1', r: '62.1' }),
                React.createElement("polyline", { className: checkClassName, "aria-describedby": 'action complete checkmark', fill: 'none', stroke: 'currentColor', strokeWidth: '3', strokeLinecap: 'round', strokeMiterlimit: '10', points: '100.2,40.2 51.5,88.8 29.8,67.5' })),
            React.createElement("div", { className: textClassName }, text || 'Success!'))));
};
export default SuccessAnimation;
